const reportWindowPath = /\/report\/(edit|view)$/;

export const toDashboardPath = (pathname: string): string => pathname.replace(reportWindowPath, "");
